import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ceres-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmDialogComponent {
    data = inject<{
        text: string;
        amount?: number;
        header: string;
        disableClose: boolean;
        confirmButtonText: string;
        cancleButtonText: string;
        disableCancleButton: boolean;
        warningText?: string;
    }>(MAT_DIALOG_DATA);
    private matDialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);

    public cancel() {
        this.matDialogRef.close();
    }

    public confirm() {
        this.matDialogRef.close(true);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.matDialogRef.close();
    }
}
